
import React, { useEffect } from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import LogViewer from '@/components/logs/LogViewer';
import { useAuth } from '@/context/AuthContext';
import LoggingService from '@/services/LoggingService';

const Logs: React.FC = () => {
  const { user } = useAuth();
  
  useEffect(() => {
    // Set user ID in logging service for proper log attribution
    if (user) {
      LoggingService.setUserId(user.id);
    }
  }, [user]);

  return (
    <DashboardLayout>
      <div className="container mx-auto py-6 space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">System Logs</h1>
        </div>
        
        <LogViewer />
      </div>
    </DashboardLayout>
  );
};

export default Logs;
